/* eslint-disable */

import Component from 'gia/Component'

import AddToList from './AddToList'
import ToggleList from './ToggleList'
import loadComponents from 'gia/loadComponents'

export default class FacetFilter extends Component {
  constructor(element) {
    super(element)
  }
  submitFilter() {
    if ($('body.home').length) {
      FWP.refresh()
      window.location = `/find-a-supplier/${window.location.search}`
    } else {
      FWP.refresh()
    }
  }

  mount() {
    let that = this

    document.querySelector('.reset-filter').addEventListener('click', e => {
      FWP.reset()
      window.location = `/find-a-supplier`
    })

    document.querySelector('.submit-filter').addEventListener('click', e => {
      e.preventDefault()
      this.submitFilter()
    })

    document.querySelector('#filter-form').addEventListener('submit', e => {
      that.submitFilter()
      e.preventDefault()
      return false
    })

    //before facet refresh
    document.addEventListener('facetwp-refresh', function() {
      let selectedVenueType = 'all'
      $('select#type option').each(function() {
        if ($(this).text() === $('.select2-selection__rendered').text()) {
          selectedVenueType = $(this).val()
        }
      })

      // if (FWP.facets['supplier_regions'].length) {
      //   FWP.facets['supplier_regions'].push('state-wide') // add state wide suppliers to region
      // }

      if (selectedVenueType && selectedVenueType !== 'all') {
        FWP.facets['services'] = [`${selectedVenueType}`] // adding the venue types users selected
      }
    })

    $(document).on('facetwp-loaded', function() {
      // load new AddToList
      const components = {
        AddToList,
        ToggleList,
      }
      loadComponents(components)

      FWP.hooks.addAction('facetwp/set_label/slider', function($this) {
        let label = $this.find('.facetwp-slider-label').text()
        const strs = label.split(' ')
        $this.find('.facetwp-slider-label').html(strs[2])
      })
    })

    setTimeout(() => {
      if ($('body.home').length && typeof FWP_HTTP.get === 'object') {
        FWP.reset()
      }
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/FacetFilter.js